import {
  AccordionGroup,
  Box,
  type CustomerQuote,
  HStack,
  RFQProtocolEnum,
  Text,
  VStack,
  useCallbackRef,
  usePortal,
} from '@talos/kyoko';
import { useDetailsDrawer } from '../../../../components/DetailsDrawer/useDetailsDrawer';
import type { ManualRFQsPanelConfig } from '../../../../types/LayoutConfig';
import { ManualRFQsBlotter } from './ManualRFQsBlotter';
import { MANUAL_RFQS_PORTAL_ID, MANUAL_RFQS_PREFIX } from './types';

interface ManualRFQsBlotterMarketTabsWrapperProps {
  panelID: string;
  panelData: ManualRFQsPanelConfig;
  onUpdatePanelData: (updates: Partial<ManualRFQsPanelConfig>) => void;
}

/**
 * This component wraps the ManualRFQsBlotter and makes it possible to use as a MarketTab in our
 * Trading layout.
 *
 */
export const ManualRFQsMarketTabsWrapper = ({
  panelID,
  panelData,
  onUpdatePanelData,
}: ManualRFQsBlotterMarketTabsWrapperProps) => {
  const { setPortalRef: filtersContainerRef } = usePortal(MANUAL_RFQS_PORTAL_ID);

  const detailsDrawer = useDetailsDrawer();

  const handleOpenCustomerQuoteDrawer = useCallbackRef((quote: CustomerQuote) => {
    detailsDrawer.openDetailsDrawer({ entity: quote });
  });

  return (
    <VStack h="100%" w="100%">
      <HStack justifyContent="space-between" w="100%" p="spacing8" background="backgroundContent">
        <Text color="colorTextImportant" fontWeight="fontWeightMedium">
          Manual RFQs
        </Text>
        <HStack gap="spacing12">
          <Box w="100%" ref={filtersContainerRef} />
        </HStack>
      </HStack>
      <Box w="100%" h="100%" style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
        <AccordionGroup key={panelID}>
          <ManualRFQsBlotter
            blotterID={`${MANUAL_RFQS_PREFIX}/${panelID}`}
            portalId={MANUAL_RFQS_PORTAL_ID}
            initialRequest={INITIAL_REQUEST}
            tabData={panelData}
            onUpdateTabData={onUpdatePanelData}
            onOpenCustomerQuoteDrawer={handleOpenCustomerQuoteDrawer}
          />
        </AccordionGroup>
      </Box>
    </VStack>
  );
};

const INITIAL_REQUEST = {
  RFQProtocol: RFQProtocolEnum.Manual,
};
